import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M19.433 6.725C19.433 3.6 18 3 16.24 3H7.63C5.627 2.99 4 4.635 4 6.66v9.053c0 2.024.317 3.531 3.618 3.659 2.382.091 15.825.016 12.348-4.663-2.453-3.303-8.516 1.597-1.55 6.308"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M7.193 7.257h9.047M7.226 10.839h7.972M7.193 14.809h4.695"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
  </svg>
);
export const TextFieldIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
